// extracted by mini-css-extract-plugin
export default {"body":"vVmp4XDH2zjcof9jZXds"};